import { useMutation } from '@tanstack/react-query'
import { getCashDonationReceipt } from '../utils/getCashDonationReceipt'

export const useDownloadCashReceiptMutation = () => {
  return useMutation({
    mutationFn: (donationId: string) => getCashDonationReceipt(donationId),
  })
}
